import { View, Text, Platform } from "react-native";
import { GuidePageHeader, GuideCard, GuideTip, GuideNav, getGuideNav } from "./_components";

const PAGE_HREF = "/(web)/guide/chat";

export default function ChatPage() {
  if (Platform.OS !== "web") return null;
  const nav = getGuideNav(PAGE_HREF);

  return (
    <View>
      <GuidePageHeader
        icon="chatbubbles"
        title="Chat"
        subtitle="Blijf in contact met de familie via berichten, groepschats, polls en meer."
        color="#6366F1"
      />

      {/* Chat types */}
      <Text className="text-xl font-bold text-gray-900 mb-4">Soorten Chats</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        De app biedt verschillende soorten chats voor elke situatie:
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="people"
          title="Familie Chat"
          description="Een automatisch aangemaakte groepschat waar alle familieleden in zitten. Hier kun je berichten delen met de hele familie."
          color="#7C3AED"
        />
        <GuideCard
          icon="person"
          title="Privé Chat"
          description="Een één-op-één gesprek met een ander familielid. Start een privé chat vanuit het chatoverzicht."
          color="#3B82F6"
        />
        <GuideCard
          icon="chatbubbles"
          title="Groepschat"
          description="Maak een eigen groepschat aan met familieleden naar keuze. Geef de groep een naam en voeg leden toe."
          color="#10B981"
        />
        <GuideCard
          icon="shield"
          title="Team Chat"
          description="Elke team heeft automatisch een eigen chat. Hier kun je met je teamgenoten overleggen over strategie en uitdagingen."
          color="#EC4899"
        />
      </View>

      {/* Berichten */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Berichten Versturen</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Je kunt verschillende soorten berichten versturen:
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="text"
          title="Tekstberichten"
          description="Typ een bericht en verstuur het. Emoji's worden ondersteund!"
          color="#6366F1"
        />
        <GuideCard
          icon="image"
          title="Foto's"
          description="Verstuur foto's vanuit je galerij. Tik op het '+' icoontje en kies 'Foto'. De foto wordt geüpload en getoond in de chat."
          color="#10B981"
        />
        <GuideCard
          icon="document"
          title="Bestanden"
          description="Deel bestanden met je familieleden. Ondersteunt diverse bestandstypen."
          color="#3B82F6"
        />
      </View>

      {/* Reageren */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Reageren op Berichten</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Je kunt op meerdere manieren reageren op berichten:
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="arrow-undo"
          title="Beantwoorden (Reply)"
          description="Swipe een bericht naar rechts om erop te antwoorden. Het originele bericht wordt getoond boven je antwoord."
          color="#6366F1"
        />
        <GuideCard
          icon="hand-left"
          title="Lang indrukken"
          description="Houd een bericht lang ingedrukt voor opties: kopiëren, bewerken (eigen berichten) of verwijderen."
          color="#EF4444"
        />
      </View>

      <GuideTip icon="swap-horizontal" title="Swipen om te reageren">
        Swipe een bericht naar rechts om snel te antwoorden. Het originele bericht wordt 
        automatisch als referentie toegevoegd aan je antwoord.
      </GuideTip>

      {/* Polls */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Polls</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Maak polls aan in elke chat om samen beslissingen te nemen of meningen te peilen!
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="bar-chart"
          title="Poll aanmaken"
          description="Tik op '+' in de chat en kies 'Poll'. Stel een vraag op en voeg 2 tot 10 antwoordopties toe."
          color="#7C3AED"
        />
        <GuideCard
          icon="checkmark-circle"
          title="Stemmen"
          description="Tik op een optie om te stemmen. Afhankelijk van de instellingen kun je op meerdere opties stemmen."
          color="#10B981"
        />
        <GuideCard
          icon="time"
          title="Deadline"
          description="Stel optioneel een deadline in waarna het stemmen sluit. De resultaten worden altijd real-time bijgewerkt."
          color="#F59E0B"
        />
      </View>

      <GuideTip variant="success" title="Anoniem stemmen">
        Bij het aanmaken van een poll kun je kiezen of stemmen anoniem zijn. Bij anonieme 
        polls zien deelnemers alleen het aantal stemmen per optie, niet wie er heeft gestemd.
      </GuideTip>

      {/* Typing indicators */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Extra Functies</Text>
      <View className="mb-6">
        <GuideCard
          icon="ellipsis-horizontal"
          title="Typ-indicatoren"
          description="Je kunt zien wanneer iemand aan het typen is. Een klein tekst verschijnt onderaan de chat."
          color="#6B7280"
        />
        <GuideCard
          icon="checkmark-done"
          title="Gelezen-meldingen"
          description="Berichten worden als gelezen gemarkeerd wanneer je ze opent. De afzender kan zien of het bericht is gelezen."
          color="#10B981"
        />
        <GuideCard
          icon="notifications"
          title="Push-meldingen"
          description="Ontvang push-meldingen voor nieuwe berichten. Je kunt per chat instellen of je meldingen wilt ontvangen."
          color="#8B5CF6"
        />
      </View>

      <GuideNav {...nav} />
    </View>
  );
}
